module.exports = __webpack_public_path__ + "img/brief_icon_tuanti.4ba37e21.png";